<template>
  <div class="container" v-if="item.data">
      <div class="photoDetail-box">
          <h1> {{item.data.story.name}} </h1>
          <p v-html="item.data.story.content.description.content"></p>
      </div>
      <div v-for="image in album" :key="image.filename"> 
          <img loading="lazy" class="img-box" :src="image.filename" alt="photo">
      </div>
  </div>
</template>



<script>
const StoryblokClient = require('storyblok-js-client');
const Storyblok = new StoryblokClient({
  accessToken: process.env.VUE_APP_KEY,
  cache: {
    clear: 'auto',
    type: 'memory'
  }
});
export default {
    name: 'photo-details',
    methods: {
      getStories() {
            Storyblok.get('cdn/stories/' + this.$route.params.full_slug)
            .then(response => {
                this.item = response;
                this.album = response.data.story.content.album
            }).catch(error => { 
                console.log(error)
            })
        },
    },
     data: function () {
        return {
            item: {},
            album: []
        }
    },
    mounted() {
        this.getStories();
    }
}
</script>



<style>
.photoDetail-box h1 {
  color: #F3A822;
  margin-bottom: 10px;
}
.photoDetail-box {
  position: relative;
  display: inline-block;
  width: 50%;
  padding: 50px 0 40px;
}
.img-box {
  width: 900px;
  margin-bottom: 50px;
}

@media only screen 
and (min-device-width : 768px) and (max-device-width : 1024px) {
.photoDetail-box {
  width: 75%;
}
.img-box {
  width: 75%;
  margin: 60px 0;
}
}
@media only screen and (max-width: 600px) {
.photoDetail-box {
  width: 75%;
}
.photoDetail-box h1 {
  font-size: 1.7rem !important;
  padding-bottom: 1rem;
}
.img-box {
  width: 75%;
  margin: 25px 0 55px;
}
}
</style>